import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TextControl } from '@shared/ui/controls/text-control.model';
import { BenchTemplateItem } from '../../../shared/interfaces/entities/bench-template-item.interface';
import { BenchTemplateService } from '../services/bench-template.service';
import { AvailableItemFilter } from '../../../shared/interfaces/select-filters/available-item.filter.interface';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { ItemsOnBenchTemplateSelect } from '../../../shared/ui/select-controls/items-on-bench-temp-select.model';
import { ItemsOnBenchTemplateFilter } from '../../../shared/interfaces/select-filters/items-on-bench-temp-filter.interface';

@Component({
  selector: 'app-bench-template-remove-items',
  standalone: false,
  templateUrl: './bench-template-remove-items.component.html',
  styleUrls: ['./bench-template-remove-items.component.css']
})
export class BenchTemplateRemoveItemsComponent implements OnInit {

  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  public submitted: boolean = false;
  saving: boolean = false;
  saveIcon = faSave;

  id: number;
  public form: FormGroup;

  itemsOnBenchTemplate: ItemsOnBenchTemplateSelect;

  constructor(private fb: FormBuilder, private auth: AuthenticationService) { }

  ngOnInit() {
    this.itemsOnBenchTemplate = new ItemsOnBenchTemplateSelect("Test", "", new Array<any>);

    var benchTemplateId: ItemsOnBenchTemplateFilter = {
      BenchTemplateId : this.id
    };
    this.itemsOnBenchTemplate.filters = benchTemplateId;

    this.form = this.fb.group({
      id: this.id,
      itemsOnBenchTemplate: null,
    });
  }

  save() {
    this.submitted = true;
    this.saving = true;

    var itemsOnBenchTemplate = this.itemsOnBenchTemplate.value?.map(x => x.id);

    this.form.controls['itemsOnBenchTemplate'].setValue(itemsOnBenchTemplate);

    this.submitForm.emit(this.form);
  }

}
